import dayjs from 'dayjs';
import groupBy from 'lodash/groupBy';
import * as DateString from '../DateString';
import * as DateTimeInterval from '../DateTimeInterval';
export const breakCases = (specialCases) => {
    const { open, closed } = groupByClosed(specialCases);
    const normalizeCases = (cases) => groupByDay(cases.map(DateTimeInterval.fromSpecialCase).flatMap(breakInterval));
    return { open: normalizeCases(open), closed: normalizeCases(closed) };
};
/**
 * Trim special cases to the days in [`dateFrom`, `dateTo`] and drop the ones outside it,
 * so a long period (e.g. a closure until 2047) is not expanded day by day beyond the range.
 */
export const clipCases = ({ specialCases, dateFrom, dateTo, }) => {
    const rangeStart = dayjs.utc(dateFrom).startOf('day');
    const rangeEnd = dayjs.utc(dateTo).startOf('day').add(1, 'd');
    if (!rangeStart.isValid() || !rangeEnd.isValid()) {
        return specialCases;
    }
    return specialCases.flatMap((specialCase) => {
        const start = dayjs.utc(specialCase.start);
        const end = dayjs.utc(specialCase.end);
        if (!start.isValid() || !end.isValid()) {
            return [specialCase];
        }
        if (!end.isAfter(rangeStart) || !start.isBefore(rangeEnd)) {
            return [];
        }
        return [
            {
                ...specialCase,
                start: start.isBefore(rangeStart)
                    ? rangeStart.toISOString()
                    : specialCase.start,
                end: end.isAfter(rangeEnd) ? rangeEnd.toISOString() : specialCase.end,
            },
        ];
    });
};
const groupByClosed = (specialCases) => ({
    open: [],
    closed: [],
    ...groupBy(specialCases, ({ isClosed }) => (isClosed ? 'closed' : 'open')),
});
const groupByDay = (intervals) => {
    const map = {};
    intervals.forEach(({ day, ...timeInterval }) => {
        if (!map[day]) {
            map[day] = [];
        }
        map[day].push(timeInterval);
    });
    return map;
};
const iterator = {
    next: (dateTime) => DateString.fromDate(dayjs.utc(dateTime).add(1, 'd')),
    prev: (dateTime) => DateString.fromDate(dayjs.utc(dateTime).subtract(1, 'd')),
    distance: (a, b) => Math.abs(dayjs.utc(a).diff(dayjs.utc(b), 'd')),
};
const breakInterval = DateTimeInterval.breakInterval(iterator);
//# sourceMappingURL=SpecialCase.js.map